export default {"src":"/_next/static/media/apple-app-store-badge.c5c0aa0e.svg","height":40,"width":121,"blurWidth":0,"blurHeight":0};